<template>
  <a-spin size="large" :spinning="loading">
    <common-layout>
      <div class="main-login">
        <div class="left" v-if="!isMobile">
          <div class="left-wrap">
            <div class="header">
              <svg-icon
                iconClass="login"
                class="logo"
                style="width: 309px; height: 44px; background: none"
              ></svg-icon>
            </div>
            <div class="left-img">
              <a-carousel autoplay dotsClass="dots">
                <div><img src="@/assets/img/login1.png" /></div>
                <div><img src="@/assets/img/login2.png" /></div>
                <div><img src="@/assets/img/login3.png" /></div>
                <div><img src="@/assets/img/login4.png" /></div>
                <div><img src="@/assets/img/login5.png" /></div>
                <div><img src="@/assets/img/login6.png" /></div>
                <div><img src="@/assets/img/login7.png" /></div>
              </a-carousel>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="login">
            <div class="title" :class="[lang]">
              {{ $t("resetYourPwd") }}
            </div>
            <div class="subTitle" :class="[lang]">
              {{ $t("InputNewPwd") }}
            </div>

            <div class="wrapForm">
              <a-form layout="vertical" :form="form" size="large">
                <div class="form-label">{{ $t("newPwd") }}</div>
                <a-form-item
                  :class="[lang]"
                  :validate-status="passwordError() ? 'error' : ''"
                  :help="passwordError() || ''"
                >
                  <a-input-password
                    :placeholder="$t('newPwd')"
                    v-decorator="[
                      'password',
                      {
                        trigger: ['blur', 'change'],
                        rules: [
                          {
                            required: true,
                            validator: function (rule, value, callback) {
                              // 检查密码长度是否少于 8 个字符
                              if (value.length < 8) {
                                callback($t('charactersDes'));
                                return;
                              }

                              // 检查是否包含大写字母
                              if (!/[A-Z]/.test(value)) {
                                callback($t('uppercaseCharacter'));
                                return;
                              }

                              // 检查是否包含小写字母
                              if (!/[a-z]/.test(value)) {
                                callback($t('lowercaseCharacter'));
                                return;
                              }

                              // 检查是否包含数字
                              if (!/[0-9]/.test(value)) {
                                callback($t('digitRequired'));
                                return;
                              }
                              // 检查是否包含特殊字符
                              if (!reg.test(value)) {
                                callback($t('specialCharacter'));
                                return;
                              }
                              callback();
                            },
                          },
                        ],
                      },
                    ]"
                  >
                    <a-icon
                      slot="prefix"
                      type="lock"
                      style="color: rgba(0, 0, 0, 0.25)"
                    />
                  </a-input-password>
                  <div
                    class="info-tips"
                    v-if="isSignUp && !passwordError() && !getPasswordValue()"
                  >
                    {{ $t("passwordDes") }}
                  </div>
                </a-form-item>
                <div class="form-label">{{ $t("confirmNewPwd") }}</div>
                <a-form-item
                  :class="[lang]"
                  :validate-status="password2Error() ? 'error' : ''"
                  :help="password2Error() || ''"
                >
                  <a-input-password
                    :placeholder="$t('confirmNewPwd')"
                    v-decorator="[
                      'password2',
                      {
                        trigger: ['blur', 'change'],
                        rules: [
                          {
                            required: true,
                            validator: function (rule, value, callback) {
                              // 检查密码长度是否少于 8 个字符
                              if (value.length < 8) {
                                callback($t('charactersDes'));
                                return;
                              }

                              // 检查是否包含大写字母
                              if (!/[A-Z]/.test(value)) {
                                callback($t('uppercaseCharacter'));
                                return;
                              }

                              // 检查是否包含小写字母
                              if (!/[a-z]/.test(value)) {
                                callback($t('lowercaseCharacter'));
                                return;
                              }

                              // 检查是否包含数字
                              if (!/[0-9]/.test(value)) {
                                callback($t('digitRequired'));
                                return;
                              }
                              // 检查是否包含特殊字符
                              if (!reg.test(value)) {
                                callback($t('specialCharacter'));
                                return;
                              }
                              if (value !== getPasswordValue()) {
                                callback($t($t('notMatch')));
                                return;
                              }
                              callback();
                            },
                          },
                        ],
                      },
                    ]"
                  >
                    <a-icon
                      slot="prefix"
                      type="lock"
                      style="color: rgba(0, 0, 0, 0.25)"
                    />
                  </a-input-password>
                </a-form-item>

                <a-form-item>
                  <a-button
                    type="primary"
                    html-type="submit"
                    style="width: 60%"
                    @click="onSubmit"
                    :disabled="
                      hasErrors(form.getFieldsError()) || !haveFormValue()
                        ? true
                        : false
                    "
                  >
                    {{ $t("resetPwd") }}
                  </a-button>
                </a-form-item>
              </a-form>
            </div>
          </div>
        </div>
      </div>
    </common-layout>
  </a-spin>
</template>

<script>
import CommonLayout from "@/layouts/CommonLayout";
// import { login } from "@/services/user";
// import { loadRoutes } from "@/utils/routerUtil";
import { mapMutations } from "vuex";
// import { useAuth0 } from "@auth0/auth0-vue";
// const auth0 = useAuth0();
import { sendData } from "@/utils/burying-point";
function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}
export default {
  name: "Login",
  components: { CommonLayout },
  data() {
    return {
      showModal: false,
      hasErrors,
      reg: /[!@#$%^&*(),".?:{}|<>]/,
      labelPosition: "right",
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      //倒计时
      countdown: 0,
      formData: {},
      loginInfo: {},
      loinFail: false,
      visiable: false,
      logging: false,
      isAuthenticated: false,
      isLoading: false,
      error: "",
      loading: false,
      form: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      showPage: false,
      showError: false,
      timer: null,
      isSignUp: true, // 是否注册
      // cloundfauture code
      turnstileToken: null,
    };
  },

  computed: {
    systemName() {
      return this.$store.state.setting.systemName;
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  i18n: require("./i18n"),
  created() {},
  mounted() {
    // 数据上报
    sendData({
      event_name: "vist_reset_pwd",
    });
    if (this.isMobile) {
      document.querySelector("#popContainer").style.minWidth = "100vw";
    } else {
      document.querySelector("#popContainer").style.minWidth = "1200px";
    }
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let { code, u } = this.$route.query;
          this.loading = true;
          this.$axios(
            "/user/reset_pwd",
            {
              code,
              email: decodeURIComponent(u),
              password: values.password,
            },
            "post"
          ).then((res) => {
            this.loading = false;
            if (res.code == 200) {
              this.$message.success(res.msg);
              localStorage.setItem("StrategyBrainLoginSuccess", true);
              setTimeout(() => {
                this.$router.push("/login");
              }, 1000);
            }
          });
        }
      });
    },
    userNameError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("userName") && getFieldError("userName");
    },
    getPasswordValue() {
      const { getFieldValue } = this.form;
      return getFieldValue("password");
    },
    haveForm2Value() {
      const { getFieldValue } = this.form2;
      return getFieldValue("verificationCode") ? true : false;
    },
    haveFormValue() {
      const { getFieldValue } = this.form;
      return getFieldValue("password") && getFieldValue("password2")
        ? true
        : false;
    },
    // Only show error after a field is touched.
    passwordError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("password") && getFieldError("password");
    },
    password2Error() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("password2") && getFieldError("password2");
    },

    ...mapMutations("account", ["setUser", "setPermissions", "setRoles"]),
  },
  beforeDestroy() {
    document.querySelector("#popContainer").style.minWidth = "1200px";
  },
};
</script>

<style lang="less" scoped>
.mask {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  .dialog {
    width: 746px;
    height: 576px;
    background: #ffffff;
    border-radius: 21px 21px 21px 21px;
    .loading {
      text-align: center;
      padding-top: 70px;
      img {
        height: 246px;
      }
    }
    .text {
      text-align: center;
      padding-top: 27px;
      font-weight: bold;
      font-size: 36px;
      color: #000000;
      padding-bottom: 27px;
    }
    .slide-wrap {
      // width: 704px !important;
      margin: 0 auto;
      height: 42px;
      .dtext {
        text-align: center;
      }
      /deep/.ant-carousel {
        // width: 704px !important;
        height: 42px;
        .slick-list {
          height: 64px;
        }
      }
      .ant-carousel .slick-slide {
        text-align: center;
        height: 160px;
        line-height: 160px;
        background: #364d79;
        overflow: hidden;
      }

      .ant-carousel .slick-slide h3 {
        color: #fff;
      }
      /deep/ .ant-carousel .slick-dots-bottom {
        bottom: -12px !important;
        height: 10px;
      }
      /deep/ .ant-carousel .slick-dots li button {
        width: 9px;
        height: 9px;
        background: #b8d1ce;
        border-radius: 50%;
        opacity: 1;
      }
      /deep/ .ant-carousel .slick-dots .slick-active button {
        width: 29px;
        height: 9px;
        background: #0e756a;
        border-radius: 4px;
      }
    }
  }
  @media screen and (max-width: 1680px) {
    .dialog {
      zoom: 0.8;
    }
  }
}
/deep/.content {
  padding: 0 !important;
}
.common-layout {
  .main-login {
    height: 100vh;
    display: flex;
    .left,
    .right {
      flex: 1;
      height: 100vh;
    }
    .right {
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .left {
      background: url(../../assets/img/left_login_bg.png) no-repeat;
      background-size: 100% 100%;
      .left-wrap {
        .header {
          position: fixed;
          top: 40px;
          left: 40px;
        }
        .left-img {
          width: 100%;
          height: 100vh;
          position: relative;
        }
        .ant-carousel {
          width: 654px;
          height: 420px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          img {
            width: 654px;
            height: 420px;
          }
        }
        @media screen and (max-width: 1680px) {
          .ant-carousel {
            width: 523px;
            height: 336px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            img {
              width: 523px;
              height: 336px;
            }
          }
        }
        .ant-carousel .slick-slide {
          text-align: center;
          height: 160px;
          line-height: 160px;
          background: #364d79;
          overflow: hidden;
        }

        .ant-carousel .slick-slide h3 {
          color: #fff;
        }
        /deep/ .ant-carousel .slick-dots-bottom {
          bottom: -12px !important;
          height: 10px;
        }
        /deep/ .ant-carousel .slick-dots li button {
          width: 9px;
          height: 9px;
          background: #b8d1ce;
          border-radius: 50%;
          opacity: 1;
        }
        /deep/ .ant-carousel .slick-dots .slick-active button {
          width: 29px;
          height: 9px;
          background: #0e756a;
          border-radius: 4px;
        }
      }
    }
  }
  .top {
    text-align: center;
    .header {
      height: 68px;
      line-height: 44px;
      a {
        text-decoration: none;
      }
      .logo {
        width: auto;
        height: 44px;
        vertical-align: top;
      }
      .title {
        font-size: 33px;
        color: @title-color;
        font-family: "Myriad Pro", "Helvetica Neue", Arial, Helvetica,
          sans-serif;
        font-weight: 600;
        position: relative;
        top: 2px;
      }
      .subTitle {
      }
    }
    .desc {
      font-size: 14px;
      color: @text-color-second;
      margin-top: 12px;
      margin-bottom: 40px;
    }
  }
  .login {
    text-align: center;
    .title {
      font-family: Arial, Arial;
      font-weight: bold;
      font-size: 34px;
      color: #0e756a;
      text-align: center;
      line-height: 40px;
      margin-bottom: 10px;
    }
    .subTitle {
      margin-top: 8px;
      font-family: Arial, Arial;
      font-weight: bold;
      font-size: 16px;
      color: #ff7810;
      text-align: center;
      background: #fff3db;
      border-radius: 4px 4px 4px 4px;
      line-height: 20px;
      padding: 8px 30px;
      display: inline-block;
    }
    .auth {
      ul,
      li {
        padding: 0;
        margin: 0;
        list-style: none;
      }
      ul {
        width: 370px;
        margin: 0 auto;
        margin-top: 20px;
      }
      li {
        cursor: pointer;
        margin-bottom: 16px;
        width: 370px;
        height: 44px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #d9d9d9;
        line-height: 42px;
        text-align: center;
        span {
          display: inline-block;
          margin-left: 10px;
          font-weight: bold;
          font-size: 16px;
          color: #000000;
        }
        &:hover {
          box-shadow: 0px 3px 6px 1px rgba(14, 117, 106, 0.2);
          border: 2px solid #0e756a;
        }
        .svg-icon {
          font-size: 20px;
        }
      }
    }
    .sign-up-tip {
      font-weight: bold;
      font-size: 14px;
      color: #000000;
      line-height: 20px;
      text-align: center;
      span {
        color: #1b7c72;
        cursor: pointer;
      }
    }
    .forget {
      font-family: Arial, Arial;
      font-weight: 400;
      font-size: 12px;
      color: #0e756a;
      cursor: pointer;
      margin-top: 30px;
      text-align: center;
    }
    // width: 100%;

    // background: #ffffff;
    // box-shadow: 0px 10px 20px 1px rgba(0, 0, 0, 0.1);
    // border-radius: 21px 21px 21px 21px;
    // margin: 0 auto;
    padding: 30px 20px;

    // @media screen and (max-width: 576px) {
    //   padding: 60px 0;
    // }
    // @media screen and (max-width: 320px) {
    //   .captcha-button {
    //     font-size: 14px;
    //   }
    // }
    .wrap-login {
      width: 360px;
      margin: 0 auto;
      margin-top: 42px;
    }
    .icon {
      font-size: 24px;
      color: @text-color-second;
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: @primary-color;
      }
    }
  }
  .noHave {
    font-family: Arial, Arial;
    font-weight: 400;
    font-size: 18px;
    text-align: center;
    margin-top: 34px;
  }
  .forget,
  .reg {
    color: #0e756a;
    text-decoration: underline;
    text-align: center;
  }
}
.fail {
  .error {
    text-align: center;
    .loginError {
      width: 38px;
      height: 34px;
    }
  }
  .login-text {
    text-align: center;
    margin-top: 8px;
    margin-bottom: 13px;
    font-weight: bold;
    font-size: 24px;
    color: #000000;
  }
  .eror-code {
    font-weight: bold;
    font-size: 16px;
    color: #999999;
    text-align: center;
  }
  .retry {
    font-weight: bold;
    font-size: 18px;
    color: #000000;
    margin-top: 65px;
    text-align: center;
  }
  .btn {
    width: 410px;
    height: 66px;
    line-height: 66px;
    margin: 0 auto;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    border: 2px solid #0e756a;
    margin-top: 27px;
    text-align: center;
    cursor: pointer;
    .icon {
      margin-right: 10px;
    }
  }
  .relogin {
    font-weight: bold;
    font-size: 20px;
    color: #ffffff;
    line-height: 66px;
    text-align: center;
    background: #0e756a;
  }
  .concatus {
    font-weight: bold;
    font-size: 20px;
    color: #0e756a;
  }

  .wrap-code {
    width: 362px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .qrcode {
      width: 144px;
    }
    img {
      display: block;
      width: 122px;
      margin: 0 auto;
      margin-top: 56px;
    }
    .text {
      margin-top: 11px;
      text-align: center;
      width: 144px;
      font-weight: bold;
      font-size: 14px;
      color: #000000;
      width: 144px;
      height: 31px;
      line-height: 31px;
      background: #eff0f0;
    }
  }
  .qus {
    font-weight: bold;
    font-size: 14px;
    color: #000000;
    margin-top: 32px;
    text-align: center;
  }
}
@media screen and (max-width: 1680px) {
  .fail {
    position: relative;
    transform: scale(0.7);
  }
  // .right .login {
  //   transform: scale(0.9);
  // }
}
@media screen and (max-width: 768px) {
  .mask {
    .dialog {
      max-width: 95%;
      zoom: 0.6;
    }
    .dtext {
      padding: 0 20px;
    }
  }
  .fail {
    position: relative;
    transform: scale(0.5);
  }
  .right {
    max-width: 100%;
    .login {
      zoom: 0.8;
    }
  }
}
@media screen and (min-width: 768px) {
  .mask .slide-wrap {
    width: 704px !important;
    /deep/.ant-carousel {
      width: 704px !important;
    }
  }
}
@media screen and (max-width: 480px) {
  .mask .dialog {
    zoom: 0.5;
  }
  .right {
    .login {
      zoom: 0.7;
    }
  }
}
</style>
<style lang="less" scoped>
.ant-tooltip.sign-up-tooltip {
  max-width: 262px;
  .ant-tooltip-inner {
    background: #496a5b;
    padding: 14px;
    border-radius: 6px;
    line-height: 22px;
    font-size: 14px;
    color: #fff;
  }
  .ant-tooltip-arrow {
    top: 9px;
    &::before {
      background: #496a5b;
      width: 10px;
      height: 10px;
    }
  }
}
.wrapForm {
  width: 390px;
  margin: 0 auto;
  margin-top: 18px;
}
.wrapForm2 {
  .codeForm {
    position: relative;
    .time {
      position: absolute;
      right: 10px;
      top: -3px;
    }
    .time2 {
      cursor: pointer;
    }
  }
}
.orline {
  margin: 10px 0px;
  text-align: center;
  display: flex;
  flex-wrap: nowrap;
  -webkit-box-align: center;
  align-items: center;
  gap: 1.5rem;
  width: 455px;
  // text-transform: uppercase;
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.8rem;
  color: rgb(140, 146, 156);
  span {
  }
}
.orline::before,
.orline::after {
  content: "";
  display: inline-block;
  border-top: 0.1rem solid rgb(227, 229, 231);
  -webkit-box-flex: 1;
  flex-grow: 1;
}
/deep/.ant-input-affix-wrapper {
  .ant-input {
    height: 42px;
  }
}
.cf-turnstile {
  width: 100%;
  margin-bottom: 12px;
}
/deep/.ant-form-explain {
  text-align: left;
}
/deep/.ant-form-item {
  margin-bottom: 8px;
}
.form-label {
  text-align: left;
  margin-bottom: 4px;
}
.info-tips {
  color: rgba(0, 0, 0, 0.35);
  text-align: left;
  font-size: 12px;
  margin-top: 5px;
}
</style>
